const CARD_SUITS = {
    CLUBS: 'clubs',
    HEARTS: 'hearts',
    SPADES: 'spades',
    DIAMONDS: 'diamonds'
}

const CARD_FACES = {
    ACE: 'ace',
    JACK: 'jack',
    QUEEN: 'queen',
    KING: 'king'
}

let value_list = Array.from({ length: 9 }, (_, i) => i + 2)
value_list = value_list.concat(Object.values(CARD_FACES))
let suit_list = Object.values(CARD_SUITS)

const createDeck = () => {
    const deck = []
    for (let suit of suit_list) {
        for (let value of value_list) {
            deck.push({ suit, value })
        }
    }
    return deck
}

const shuffleDeck = (deck = []) => {
    const deckCopy = [...deck]
    for (let i = deckCopy.length - 1; i > 0; i--) {
        const exchangeIndex = randomBetween(0, i)
        const card = deckCopy[i]
        deckCopy[i] = deckCopy[exchangeIndex]
        deckCopy[exchangeIndex] = card
    }
    return deckCopy
}

const isFaceCard = (card) => {
    return Object.values(CARD_FACES).includes(card.value)
}

const scoreStack = (cardStack) => {
    let score = 0
    let aces = 0

    for (let card of cardStack) {
        if (card.value === CARD_FACES.ACE) aces++
        score += scoreCard(card)
    }

    score = reduceAcesIfNeeded(score, aces)

    return score
}

const scoreCard = (card) => {
    if (typeof card.value === 'number') return card.value
    if (card.value === CARD_FACES.ACE) return 11
    return 10
}

const reduceAcesIfNeeded = (score, aces) => {
    while (aces > 0) {
        if (score <= 21) break
        score -= 10
        aces -= 1
    }
    return score
}

const randomBetween = (min = 0, max = 1) => {
    return Math.round(Math.random() * (max - min)) + min
}

export {
    CARD_SUITS,
    CARD_FACES,
    createDeck,
    shuffleDeck,
    isFaceCard,
    scoreStack
}